"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var S = __importStar(require("./LftGrid.styles"));
var LftGrid = function (_a) {
    /* Fiz a lógica de duas formas, depois decidimos qual vai ficar, eu prefiro a debaixo que deixei sem comentar kk
    const breakpointsValues = [sm, md, lg, xl];
    
    for (let index = 0; index < (breakpointsValues.length - 1); index++) {
      if (breakpointsValues[index]) {
        const nextIndex =  index + 1;
        if (!breakpointsValues[nextIndex]) {
          breakpointsValues[nextIndex] = breakpointsValues[index]
          switch (nextIndex) {
            case 1:
              md = breakpointsValues[nextIndex];
              break;
            case 2:
              lg = breakpointsValues[nextIndex];
              break;
            case 3:
              xl = breakpointsValues[nextIndex];
              break;
          }
        }
      }
    }*/
    var alignItems = _a.alignItems, alignSelf = _a.alignSelf, children = _a.children, container = _a.container, dataSection = _a.dataSection, dataTestId = _a.dataTestId, id = _a.id, item = _a.item, justifyContent = _a.justifyContent, rule = _a.rule, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    if (sm) {
        if (!xl) {
            // @ts-ignore
            xl = sm * 3;
        }
        if (!lg) {
            // @ts-ignore
            lg = sm * 3;
        }
        if (!md) {
            // @ts-ignore
            md = sm * 2;
        }
    }
    if (dataSection) {
        if (dataSection.startsWith('section_')) {
            console.warn('Não é necessário mais o prefixo section_ no atributo dataSection');
        }
        else
            dataSection = "section_" + dataSection;
    }
    if (container) {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!container && ((0, jsx_runtime_1.jsx)(S.Container, __assign({ alignItems: alignItems, container: container, "data-lift": "lft-grid", "data-section": dataSection, "data-testid": dataTestId ? dataTestId : id && id, id: id, justifyContent: justifyContent, rule: rule }, { children: children }), void 0)) }, void 0));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!item && ((0, jsx_runtime_1.jsx)(S.Item, __assign({ item: item, sm: sm, md: md, lg: lg, xl: xl, "data-section": dataSection, "data-testid": dataTestId ? dataTestId : id && id, alignSelf: alignSelf, alignItems: alignItems }, { children: children }), void 0)) }, void 0));
    }
};
exports.default = LftGrid;
